export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      products: 'Products',
      services: 'Services',
      contact: 'Contact Us'
    },
    // Home Page
    home: {
      heroTitle: 'Your Trusted Partner in HoReCa Excellence',
      heroSubtitle: 'Premium Quality Food & Beverage Supplies for Hotels, Restaurants & Cafes across Oman',
      heroCta: 'Explore Products',
      heroCtaSecondary: 'Contact Us',
      experienceYears: '30+',
      experienceLabel: 'Years of Experience',
      customers: '200+',
      customersLabel: 'Happy Customers',
      products: '1000+',
      productsLabel: 'Quality Products',
      teamExperience: '15+',
      teamExperienceLabel: 'Years Team Expertise',
      whyChooseTitle: 'Why Choose Taj Gulf Trading?',
      whyChooseSubtitle: 'Your success is our priority',
      featuredProductsTitle: 'Featured Products',
      featuredProductsSubtitle: 'Premium quality products for your business',
      viewAllProducts: 'View All Products'
    },
    // About Page
    about: {
      title: 'About Taj Gulf Trading LLC',
      subtitle: 'Building lasting partnerships through quality and trust',
      founderTitle: 'Founder with 30+ Years Experience',
      founderText: 'Our founder brings over three decades of expertise in the HoReCa industry, understanding the unique needs of hotels, restaurants, and cafes across Oman.',
      teamTitle: 'Experienced Sales Team',
      teamText: 'Our dedicated sales team has 15+ years of combined experience, providing personalized service and expert product knowledge to meet your specific requirements.',
      missionTitle: 'Our Mission',
      missionText: 'To deliver premium quality food and beverage supplies with exceptional service, helping our clients succeed in the competitive HoReCa industry.',
      visionTitle: 'Our Vision',
      visionText: 'To be the most trusted and preferred HoReCa supplier in Oman, known for quality, reliability, and customer-centric solutions.',
      valuesTitle: 'Our Values',
      quality: 'Quality First',
      qualityText: 'We source only the finest products from trusted global brands',
      reliability: 'Reliability',
      reliabilityText: 'Consistent delivery and service you can count on',
      partnership: 'Partnership',
      partnershipText: 'Building long-term relationships with our clients',
      integrity: 'Integrity',
      integrityText: 'Honest, transparent business practices always'
    },
    // Products Page
    products: {
      title: 'Our Products',
      subtitle: 'Premium quality products from trusted brands',
      categories: 'Product Categories',
      breakfast: 'Breakfast & Cereals',
      pasta: 'Pasta & Grains',
      baking: 'Baking Ingredients',
      dairy: 'Dairy Products',
      beverages: 'Beverages',
      condiments: 'Condiments & Sauces',
      inquiry: 'Inquire Now'
    },
    // Services Page
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions for your HoReCa needs',
      service1Title: 'Bulk Supply & Distribution',
      service1Text: 'Reliable bulk supply of food and beverage products with efficient distribution across Oman.',
      service2Title: 'Custom Product Sourcing',
      service2Text: 'Need a specific product? Our team can source specialized items to meet your unique requirements.',
      service3Title: 'Inventory Management Support',
      service3Text: 'We help you maintain optimal inventory levels with flexible ordering and delivery schedules.',
      service4Title: 'Quality Assurance',
      service4Text: 'All products undergo strict quality checks to ensure freshness and compliance with standards.',
      service5Title: 'Competitive Pricing',
      service5Text: 'Volume-based pricing and special offers for our valued long-term partners.',
      service6Title: 'Expert Consultation',
      service6Text: 'Our experienced team provides product recommendations and industry insights.',
      ctaTitle: 'Ready to Partner with Us?',
      ctaText: 'Contact us today to discuss your requirements',
      ctaButton: 'Get Started'
    },
    // Contact Page
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      formTitle: 'Send us a Message',
      name: 'Full Name',
      namePlaceholder: 'Enter your name',
      email: 'Email Address',
      emailPlaceholder: 'Enter your email',
      phone: 'Phone Number',
      phonePlaceholder: 'Enter your phone number',
      business: 'Business Name',
      businessPlaceholder: 'Enter your business name',
      message: 'Message',
      messagePlaceholder: 'Tell us about your requirements',
      submit: 'Send Message',
      infoTitle: 'Contact Information',
      whatsapp: 'WhatsApp',
      hours: 'Business Hours',
      hoursText: 'Saturday - Thursday: 8:00 AM - 6:00 PM',
      success: 'Message sent successfully! We will contact you soon.',
      error: 'Failed to send message. Please try WhatsApp instead.'
    },
    // Footer
    footer: {
      about: 'About Us',
      aboutText: 'Taj Gulf Trading LLC is your trusted partner for premium HoReCa supplies in Oman.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact Info',
      followUs: 'Follow Us',
      rights: 'All rights reserved.',
      whatsappFloat: 'Chat with us on WhatsApp'
    }
  },
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      products: 'المنتجات',
      services: 'الخدمات',
      contact: 'اتصل بنا'
    },
    // Home Page
    home: {
      heroTitle: 'شريكك الموثوق في التميز في قطاع الفنادق والمطاعم',
      heroSubtitle: 'إمدادات غذائية ومشروبات عالية الجودة للفنادق والمطاعم والمقاهي في جميع أنحاء عمان',
      heroCta: 'استكشف المنتجات',
      heroCtaSecondary: 'اتصل بنا',
      experienceYears: '+30',
      experienceLabel: 'سنة من الخبرة',
      customers: '+200',
      customersLabel: 'عميل سعيد',
      products: '+1000',
      productsLabel: 'منتج عالي الجودة',
      teamExperience: '+15',
      teamExperienceLabel: 'سنة خبرة الفريق',
      whyChooseTitle: 'لماذا تختار تاج الخليج للتجارة؟',
      whyChooseSubtitle: 'نجاحك هو أولويتنا',
      featuredProductsTitle: 'المنتجات المميزة',
      featuredProductsSubtitle: 'منتجات عالية الجودة لعملك',
      viewAllProducts: 'عرض جميع المنتجات'
    },
    // About Page
    about: {
      title: 'عن تاج الخليج للتجارة ذ.م.م',
      subtitle: 'بناء شراكات دائمة من خلال الجودة والثقة',
      founderTitle: 'مؤسس يتمتع بخبرة تزيد عن 30 عامًا',
      founderText: 'يتمتع مؤسسنا بأكثر من ثلاثة عقود من الخبرة في صناعة الفنادق والمطاعم، ويفهم الاحتياجات الفريدة للفنادق والمطاعم والمقاهي في جميع أنحاء عمان.',
      teamTitle: 'فريق مبيعات ذو خبرة',
      teamText: 'يتمتع فريق المبيعات المتفاني لدينا بخبرة مشتركة تزيد عن 15 عامًا، حيث يقدم خدمة شخصية ومعرفة متخصصة بالمنتجات لتلبية متطلباتك المحددة.',
      missionTitle: 'مهمتنا',
      missionText: 'تقديم إمدادات الأغذية والمشروبات عالية الجودة مع خدمة استثنائية، لمساعدة عملائنا على النجاح في صناعة الفنادق والمطاعم التنافسية.',
      visionTitle: 'رؤيتنا',
      visionText: 'أن نكون المورد الأكثر ثقة وتفضيلاً للفنادق والمطاعم في عمان، معروفين بالجودة والموثوقية والحلول التي تركز على العملاء.',
      valuesTitle: 'قيمنا',
      quality: 'الجودة أولاً',
      qualityText: 'نحصل فقط على أفضل المنتجات من العلامات التجارية العالمية الموثوقة',
      reliability: 'الموثوقية',
      reliabilityText: 'التسليم والخدمة المتسقة التي يمكنك الاعتماد عليها',
      partnership: 'الشراكة',
      partnershipText: 'بناء علاقات طويلة الأمد مع عملائنا',
      integrity: 'النزاهة',
      integrityText: 'ممارسات تجارية صادقة وشفافة دائمًا'
    },
    // Products Page
    products: {
      title: 'منتجاتنا',
      subtitle: 'منتجات عالية الجودة من علامات تجارية موثوقة',
      categories: 'فئات المنتجات',
      breakfast: 'الإفطار والحبوب',
      pasta: 'المعكرونة والحبوب',
      baking: 'مكونات الخبز',
      dairy: 'منتجات الألبان',
      beverages: 'المشروبات',
      condiments: 'التوابل والصلصات',
      inquiry: 'استفسر الآن'
    },
    // Services Page
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول شاملة لاحتياجات الفنادق والمطاعم الخاصة بك',
      service1Title: 'الإمداد بالجملة والتوزيع',
      service1Text: 'إمداد موثوق بالجملة من منتجات الأغذية والمشروبات مع توزيع فعال في جميع أنحاء عمان.',
      service2Title: 'توريد المنتجات المخصصة',
      service2Text: 'هل تحتاج إلى منتج معين؟ يمكن لفريقنا الحصول على عناصر متخصصة لتلبية متطلباتك الفريدة.',
      service3Title: 'دعم إدارة المخزون',
      service3Text: 'نساعدك في الحفاظ على مستويات المخزون المثلى مع جداول الطلب والتسليم المرنة.',
      service4Title: 'ضمان الجودة',
      service4Text: 'تخضع جميع المنتجات لفحوصات جودة صارمة لضمان النضارة والامتثال للمعايير.',
      service5Title: 'أسعار تنافسية',
      service5Text: 'التسعير على أساس الحجم والعروض الخاصة لشركائنا على المدى الطويل.',
      service6Title: 'استشارة الخبراء',
      service6Text: 'يقدم فريقنا ذو الخبرة توصيات المنتجات ورؤى الصناعة.',
      ctaTitle: 'هل أنت مستعد للشراكة معنا؟',
      ctaText: 'اتصل بنا اليوم لمناقشة متطلباتك',
      ctaButton: 'ابدأ الآن'
    },
    // Contact Page
    contact: {
      title: 'اتصل بنا',
      subtitle: 'تواصل مع فريقنا',
      formTitle: 'أرسل لنا رسالة',
      name: 'الاسم الكامل',
      namePlaceholder: 'أدخل اسمك',
      email: 'عنوان البريد الإلكتروني',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      phone: 'رقم الهاتف',
      phonePlaceholder: 'أدخل رقم هاتفك',
      business: 'اسم العمل',
      businessPlaceholder: 'أدخل اسم عملك',
      message: 'الرسالة',
      messagePlaceholder: 'أخبرنا عن متطلباتك',
      submit: 'إرسال الرسالة',
      infoTitle: 'معلومات الاتصال',
      whatsapp: 'واتساب',
      hours: 'ساعات العمل',
      hoursText: 'السبت - الخميس: 8:00 صباحًا - 6:00 مساءً',
      success: 'تم إرسال الرسالة بنجاح! سنتواصل معك قريبًا.',
      error: 'فشل إرسال الرسالة. يرجى المحاولة عبر واتساب بدلاً من ذلك.'
    },
    // Footer
    footer: {
      about: 'من نحن',
      aboutText: 'تاج الخليج للتجارة ذ.م.م هي شريكك الموثوق للإمدادات الفاخرة للفنادق والمطاعم في عمان.',
      quickLinks: 'روابط سريعة',
      contactInfo: 'معلومات الاتصال',
      followUs: 'تابعنا',
      rights: 'جميع الحقوق محفوظة.',
      whatsappFloat: 'تحدث معنا على واتساب'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
